import {AI_PROMO_STATUSES} from '../../configs/aiMatch';

// После старта матча зритель уходит прямо на поле — объяснять, почему он
// не игрок, уже поздно и незачем; отмененный день закрывает лобби само
const NOTICE_FINISHED_STATUSES = new Set([AI_PROMO_STATUSES.GAME_STARTED, AI_PROMO_STATUSES.CANCELLED]);

/**
 * Зритель ли пользователь ИИ-лобби до старта матча: мест не осталось (или
 * уже идут баны), и сервер пустил его смотреть (joinedAsSpectator). Он есть
 * среди зрителей лобби и нет среди игроков.
 *
 * @param {Object} lobby - private.lobby
 * @param {string|null} userId
 * @returns {boolean}
 */
export const checkIfAiLobbySpectator = (lobby, userId) => Boolean(lobby?.isAiMatch)
  && Boolean(userId)
  && !(lobby.players || []).some((player) => player?.id === userId)
  && (lobby.spectators || []).some((spectator) => spectator?.id === userId);

/**
 * Показать ли модалку «Лобби заполнено — вы зритель». Один раз на лобби за
 * сессию страницы: LOBBY_UPDATE приходит на каждое изменение состава, и
 * закрытая модалка не должна всплывать снова. Какие лобби уже показаны,
 * хранит вызывающий код (shownLobbyIds).
 *
 * @param {Object} params
 * @param {Object} params.lobby - private.lobby
 * @param {string|null} params.userId
 * @param {Set<string>} [params.shownLobbyIds]
 * @returns {boolean}
 */
export const checkIfAiLobbySpectatorNoticeDue = ({lobby, userId, shownLobbyIds}) => {
  if (!checkIfAiLobbySpectator(lobby, userId)) return false;
  if (!lobby.lobbyId || shownLobbyIds?.has(lobby.lobbyId)) return false;
  if (lobby.status === 'game_started') return false;
  return !NOTICE_FINISHED_STATUSES.has(lobby.aiPromo?.status);
};
